export type ThemeShape = 'rounded' | 'square';

export interface ThemeTokens {
    primary: string;
    secondary: string;
    accent: string;
    background: string;
    text: string;
    textSecondary: string;
    shape: ThemeShape;
}

export interface BrandingConfig {
    tokens: ThemeTokens;
    brandImageUrl: string | null;
}

export const BRANDING_STORAGE_KEY = 'khaata-pos-branding';

export const DEFAULT_THEME_TOKENS: ThemeTokens = {
    primary: '#6e78ff',
    secondary: '#c4b608',
    accent: '#ff7e32',
    background: '#f5f6ff',
    text: '#1f2340',
    textSecondary: '#6b7190',
    shape: 'rounded',
};

export const DEFAULT_BRANDING: BrandingConfig = {
    tokens: DEFAULT_THEME_TOKENS,
    brandImageUrl: null,
};

export const THEME_PRESETS: Record<string, ThemeTokens> = {
    default: DEFAULT_THEME_TOKENS,
    ocean: {
        primary: '#0891b2',
        secondary: '#0e7490',
        accent: '#f59e0b',
        background: '#ecfeff',
        text: '#164e63',
        textSecondary: '#547085',
        shape: 'rounded',
    },
    sunset: {
        primary: '#e11d48',
        secondary: '#f97316',
        accent: '#eab308',
        background: '#fff7ed',
        text: '#431407',
        textSecondary: '#7c2d12',
        shape: 'rounded',
    },
    forest: {
        primary: '#059669',
        secondary: '#65a30d',
        accent: '#d97706',
        background: '#f0fdf4',
        text: '#14532d',
        textSecondary: '#3f6212',
        shape: 'square',
    },
    lavender: {
        primary: '#7c3aed',
        secondary: '#a78bfa',
        accent: '#ec4899',
        background: '#f5f3ff',
        text: '#2e1065',
        textSecondary: '#6d28d9',
        shape: 'rounded',
    },
    coral: {
        primary: '#f43f5e',
        secondary: '#fb7185',
        accent: '#fb923c',
        background: '#fff1f2',
        text: '#4c0519',
        textSecondary: '#9f1239',
        shape: 'rounded',
    },
    midnight: {
        primary: '#3730a3',
        secondary: '#6366f1',
        accent: '#22d3ee',
        background: '#eef2ff',
        text: '#1e1b4b',
        textSecondary: '#4338ca',
        shape: 'square',
    },
    citrus: {
        primary: '#ca8a04',
        secondary: '#eab308',
        accent: '#84cc16',
        background: '#fefce8',
        text: '#422006',
        textSecondary: '#854d0e',
        shape: 'rounded',
    },
};

export interface ShapeRadii {
    sm: number;
    md: number;
    lg: number;
    xl: number;
    pill: number;
}

export const SHAPE_RADII: Record<ThemeShape, ShapeRadii> = {
    rounded: { sm: 8, md: 12, lg: 16, xl: 20, pill: 9999 },
    square: { sm: 2, md: 4, lg: 4, xl: 4, pill: 4 },
};

export const getShapeRadii = (shape: ThemeShape): ShapeRadii => SHAPE_RADII[shape];
